import { useQuery } from "@tanstack/react-query";
import { DateTime } from "luxon";

import { explosivesAjax } from "../../ajax/ExplosivesAjax";
import { personnelAjax } from "../../ajax/PersonnelAjax";
import { FlatGroupOption } from "../../DTOs/Common/FlatGroupOption";
import { ExplosiveMaterialOptionDTO, MagazineStockDTO, PersonOptionDTO } from "../../DTOs/DrillBlast/ExplosivesDTO";
import { LOOKUP_STALE_TIME, lookupQuery } from "./useDrillBlastLookups";

export const EXPIRY_WARNING_DAYS = 30;

export const expiresSoon = (expires?: DateTime | null) => expires != null && expires.diffNow("days").days < EXPIRY_WARNING_DAYS;

export const explosivesStockQuery = lookupQuery<MagazineStockDTO>(['drillBlast', 'explosivesStock'], 'the magazines', () => explosivesAjax.getStock());

export const explosiveMaterialsQuery = lookupQuery<ExplosiveMaterialOptionDTO>(['references', 'drillBlast', 'explosiveMaterials'], 'the explosives products',
  () => explosivesAjax.getMaterials(), LOOKUP_STALE_TIME);

export const personOptionsQuery = lookupQuery<PersonOptionDTO>(['references', 'drillBlast', 'personOptions'], 'the people',
  () => personnelAjax.getOptions(), LOOKUP_STALE_TIME);

export const openBlastsQuery = lookupQuery<FlatGroupOption>(['drillBlast', 'openBlasts'], 'the blasts', () => explosivesAjax.getOpenBlasts(), 60 * 1000);

export const explosivesTransactionsKey = (dayIso: string | null) => ['drillBlast', 'explosivesTransactions', dayIso];

export const explosivesTransactionsCacheKey = (dayIso: string | null) => ['dataTable', ...explosivesTransactionsKey(dayIso), 'all', false, null];

const NONE: never[] = [];

export const useExplosiveMaterials = () => useQuery(explosiveMaterialsQuery).data ?? NONE;
export const usePersonOptions = () => useQuery(personOptionsQuery).data ?? NONE;
export const useOpenBlasts = (enabled: boolean) => useQuery({ ...openBlastsQuery, enabled }).data ?? NONE;
